import React from 'react'
import { Text } from '@react-pdf/renderer'
import { useTranslation } from 'react-i18next'
import { commonStyles, createDirectionalStyles } from './Title/CommonUtils'

import * as theme from './theme'

export type TProps = {
  error: Error
}

export const PDFError = ({ error }: TProps): JSX.Element => {
  const { t, i18n } = useTranslation()
  const directionalStyles = createDirectionalStyles(commonStyles, i18n.language)

  return (
    <Text style={[theme.styles.errorText, directionalStyles.textAlign]}>
      {t('alarm_report.errors.failedToLoadReportWithDetails', {
        details: error.toString(),
      })}
    </Text>
  )
}
